angular.module('app').directive('topicResearchComplete', [
  () => {
    let link = (scope) => {
      scope.isVisible = {
        suggestions: false,
      };

      // dummy data
      scope.categories = [
        "1-9", "A-C", "D-F", "G-I", "J-L", "M-O", "P-R", "S-U", "V-Z"
      ];

      scope.categoriesData = [
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['a', 'b', 'c'],
        ['d', 'e', 'f'],
        ['g', 'h', 'i'],
        ['j', 'k', 'l'],
        ['m', 'n', 'o'],
        ['p', 'q', 'r'],
        ['s', 't', 'u'],
        ['v', 'w', 'x', 'y', 'z']
      ];

      scope.filteredChoices = scope.topics;

      scope.selectedCategoryIndex = 0;
      scope.categorySelect = index => { 
        scope.selectedCategoryIndex = index;
        scope.enteredtext = scope.categories[index].toLowerCase().substr(0, 1);
        scope.searchTitle();
      };

      scope.searchTitle = () => {
        if (scope.enteredtext.length < 0) {
          return;
        }
        scope.searchhandler('topic', scope.enteredtext, 1);
      };

      scope.filterItemsByCategory = () => {
        if (!scope.enteredtext.length) {
          scope.isVisible.suggestions = false;
          return;
        }
        scope.isVisible.suggestions = true;

        scope.selectedCategoryIndex = scope.categoriesData.findIndex(cat => cat.includes(scope.enteredtext.toLowerCase().substr(0, 1)));

        scope.filteredChoices = scope.filteredChoices.filter(attrib => {
          return scope.categoriesData[scope.selectedCategoryIndex].includes(attrib.toLowerCase().substr(0, 1));
        });
      };

      scope.selectItem = (choice) => {
        scope.enteredtext = choice;
        scope.isVisible.suggestions = false;
        scope.selecthandle(scope.selecttype, choice);
      };

      scope.filterItems = () => {  
        if (!scope.enteredtext.length) {
          scope.isVisible.suggestions = false;
          return;
        }
        scope.isVisible.suggestions = true;
        scope.filteredChoices = scope.topics.filter(attr => { 
          let search = scope.enteredtext.toLowerCase();
          let title = attr.toLowerCase();
          return title.startsWith(search.substr(0, 1)) && title.includes(search);
        }); 
        scope.selectedCategoryIndex = scope.categoriesData.findIndex(cat => cat.includes(scope.enteredtext.substr(0, 1))); 
        scope.filterItemsByCategory();
      }; 

      scope.$watch('topics', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          scope.topics = newValue;
          scope.filterItems();
        }
      }, true);

      scope.$watch('enteredtext', function (enteredtext) {
        if (!enteredtext) {
          scope.isVisible.suggestions = false;
        }
      }, true);
    };
    return {
      restrict: "E",
      templateUrl: "app/directives/dbColorResearchData/topicResearchComplete/topicResearchCompleteView.html",
      link: link,
      scope: {
        enteredtext: "=",
        placeholder: "=",
        selecthandle: "=",
        selecttype: "=",
        searchhandler: "=",
        topics: "=",
      }
    };
  }
]);
